export default __webpack_public_path__ + "static/media/compatibility.cbbb0c0e.svg";